import { useState } from "react";
import { faqList } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="border-y border-background-200 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 font-label text-xs tracking-[0.25em] text-primary-600">
              <span className="h-px w-6 bg-primary-500" />
              FAQ
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              吃瓜之前，先弄清楚这几件事
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              榜单是观察工具，不是判决书。下面这些问题是用户问得最多的，如果你还有别的疑问，欢迎直接联系我们。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
                <i className="ri-question-answer-line text-primary-600" />
                没有找到答案？
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                把你的疑问或线索写进订阅表单的备注里，我们会在核实后回复，并更新对应话题的扩散记录。
              </p>
              <a
                href="#subscribe"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                前往留言
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <dl className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqList.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.question}>
                    <dt>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
                      >
                        <span className="flex items-start gap-3">
                          <span className="font-heading text-sm font-bold text-primary-600">
                            {String(index + 1).padStart(2, "0")}
                          </span>
                          <span className="font-heading text-base font-bold text-foreground-950">
                            {item.question}
                          </span>
                        </span>
                        <i
                          className={`shrink-0 text-xl text-foreground-400 transition-transform ${
                            isOpen ? "ri-subtract-line" : "ri-add-line"
                          }`}
                        />
                      </button>
                    </dt>
                    {isOpen && (
                      <dd className="px-5 pb-5 pl-[52px] pr-6 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[60px]">
                        {item.answer}
                      </dd>
                    )}
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}